package app.nestbridge.feature.children.screen

import com.karawek.core.circuit.Parcelize
import com.slack.circuit.runtime.CircuitUiState
import com.slack.circuit.runtime.screen.Screen

@Parcelize
data object ChildrenScreen : Screen

data class ChildrenState(
    val eventSink: (ChildrenEvent) -> Unit,
) : CircuitUiState

sealed interface ChildrenEvent
